"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectPosition = exports.SelectSize = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var react_2 = require("react");
var Styled = __importStar(require("./Select.styled"));
var chevron_down_16_svg_1 = __importDefault(require("@/assets/svg/chevron-down-16.svg"));
var hooks_1 = require("@/hooks");
exports.SelectSize = {
    xs: 'xs',
    sm: 'sm',
    md: 'md',
};
exports.SelectPosition = {
    top: 'top',
    bottom: 'bottom',
};
var Select = function (_a, ref) {
    var className = _a.className, size = _a.size, label = _a.label, _b = _a.required, required = _b === void 0 ? false : _b, _c = _a.position, position = _c === void 0 ? exports.SelectPosition.bottom : _c, _d = _a.placeholder, placeholder = _d === void 0 ? '전체' : _d, options = _a.options, _e = _a.isFullWidth, isFullWidth = _e === void 0 ? false : _e, defaultValue = _a.defaultValue, currentValue = _a.currentValue, onChangeOption = _a.onChangeOption, _f = _a.disabled, disabled = _f === void 0 ? false : _f;
    var _g = __read((0, react_2.useState)(false), 2), isOpened = _g[0], setOpened = _g[1];
    var _h = __read((0, react_2.useState)(defaultValue), 2), selectedOption = _h[0], setSelectedOption = _h[1];
    var containerRef = (0, react_2.useRef)(null);
    var toggleOpened = function () {
        if (disabled) {
            return;
        }
        setOpened(!isOpened);
    };
    var handleClickOption = function (option) {
        setSelectedOption(option);
        toggleOpened();
        onChangeOption === null || onChangeOption === void 0 ? void 0 : onChangeOption(option);
    };
    (0, react_2.useEffect)(function () {
        if (defaultValue) {
            setSelectedOption(defaultValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.value]);
    (0, react_2.useEffect)(function () {
        if (currentValue) {
            setSelectedOption(currentValue);
        }
    }, [currentValue]);
    (0, hooks_1.useOnClickOutSide)(containerRef, function () {
        setOpened(false);
    });
    return ((0, jsx_runtime_1.jsxs)(Styled.SelectContainer, __assign({ ref: containerRef, className: className, isFullWidth: isFullWidth }, { children: [(0, jsx_runtime_1.jsx)(Styled.Select, { "$size": size, label: label, required: required, ref: ref, onClick: toggleOpened, isOpened: isOpened, position: position, disabled: disabled, placeholder: placeholder, endIcon: (0, jsx_runtime_1.jsx)(chevron_down_16_svg_1.default, {}, void 0), value: (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) || (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.label), readOnly: true, fill: true }, void 0), (0, jsx_runtime_1.jsx)(Styled.SelectMenu, __assign({ isOpened: isOpened, position: position }, { children: options.map(function (option) { return ((0, jsx_runtime_1.jsx)(Styled.SelectOption, __assign({ isSelected: (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) === option.value, onClick: function () { return handleClickOption(option); } }, { children: option.label }), option.value)); }) }), void 0)] }), void 0));
};
exports.default = (0, react_2.forwardRef)(Select);
